// DRAFT — REVIEW ARTIFACT — NOT DEPLOYED
//
// The artifacts data layer: list_reporting_artifacts(_cycle_id) — the artifact pointer rows
// for a cycle (ir, react_view, the five decks, the newsletter). Object bytes are NEVER
// returned here; sign_reporting_artifact returns a jsonb authorization GRANT (0003c:362-406 ->
// 0003b:443-502), not a URL, and a service-role signer must convert it.
//
// That signer is now REACHED FOR by useNewsletterReview's preview hook (the retail newsletter
// must be readable before it can be reviewed) but is NOT deployed: there is no
// reporting-artifact-fetch edge function, and 0003b:429-431 deliberately declines a
// storage.objects read policy for the bucket. The preview degrades to an explicit
// "cannot display" state rather than a blank. Deck kinds remain pointer-only by design.

import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { LegacyTier, ReportingTier } from "@/types/ir";

type Row = Record<string, any>;

// reporting_artifacts (0001 + 0003b columns). SELECT * so whatever columns exist at call
// time flow through; typed permissively.
export interface ReportingArtifactRow extends Row {
  id?: string;
  cycle_id?: string;
  kind?: string; // ir | react_view | deck_ic | deck_exec | deck_ext_ic | deck_adviser | deck_retail | newsletter
  storage_path?: string | null;
  sensitivity_tier?: LegacyTier | ReportingTier;
  artifact_sha256?: string | null;
  spec_sha256?: string | null;
  ir_sha256?: string | null;
  render_engine_version?: string | null;
  bytes?: number | null;
  content_type?: string | null;
  storage_bucket?: string | null;
  rendered_at?: string | null;
  render_job_id?: string | null;
  created_at?: string;
}

export function useReportingArtifacts(cycleId: string | undefined) {
  return useQuery({
    queryKey: ["list_reporting_artifacts", cycleId],
    enabled: !!cycleId,
    staleTime: 2 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await (supabase as any).rpc("list_reporting_artifacts", { _cycle_id: cycleId });
      if (error) throw error;
      return ((data as ReportingArtifactRow[]) ?? []).filter(Boolean);
    },
  });
}
